<template>
  <div v-if="isVisible" class="background" :style="{ top: isFullScreen ? '0' : '50px', height: isFullScreen ? '100%' : 'calc(100% - 50px)' }">
    <div class="themes" v-if="testingMode">
      <button style="padding: 5px; font-size: 10px; margin: 2px" @click="themeChanged(0)">Theme 1</button>
      <button style="padding: 5px; font-size: 10px; margin: 2px" @click="themeChanged(1)">Theme 2</button>
      <button style="padding: 5px; font-size: 10px; margin: 2px" @click="themeChanged(2)">Theme 3</button>
      <button style="padding: 5px; font-size: 10px; margin: 2px" @click="themeChanged(3)">Theme 4</button>
      <button style="padding: 5px; font-size: 10px; margin: 2px" @click="themeChanged(4)">Theme 5</button>
    </div>
    <!-- <button @click="pauseClick()">Play / Pause</button> -->
    <div v-if="theme1" class="spinner-area">
      <div class="loader top" :style="{ animationPlayState: animationState }"/>
      <div class="loader right" :style="{ animationPlayState: animationState }"/>
      <div class="loader bottom" :style="{ animationPlayState: animationState }"/>
      <div class="loader left" :style="{ animationPlayState: animationState }"/>
    </div>

    <div v-if="theme2" class="spinner-area theme2">
      <div class="dot first"></div>
      <div class="dot second"></div>
      <div class="dot third"></div>
      <div class="dot fourth"></div>
      <div class="dot fifth"></div>
      <div class="dot sixth"></div>
    </div>

    <div v-if="theme3" class="spinner-area theme3">
      <div class="half first"></div>
      <div class="half second"></div>
      <div class="half third"></div>
      <div class="half fourth"></div>
      <div class="half fifth"></div>
      <div class="half sixth"></div>
      <div class="half seventh"></div>
    </div>

    <div v-if="theme4" class="spinner-area theme4">
      <div class="bar first"></div>
      <div class="bar second"></div>
      <div class="bar third"></div>
      <div class="bar fourth"></div>
      <div class="bar fifth"></div>
      <div class="bar sixth"></div>
      <div class="bar seventh"></div>
    </div>

    <div v-if="theme5" class="spinner-area theme5" style="width: 200px; height: 100px">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background-color: transparent" preserveAspectRatio="xMidYMid meet" viewBox="0 60 640 400" width="640" height="100">
        <g>
          <!-- Original -->
          <!-- <path class="elms" :style="{ animationPlayState: animationE }" style="animation-delay: 0s; animation-duration: 1.5s" fill="none" stroke="white" stroke-width="15" d="M220 399.45C153.34 419.4 120.02 411.06 120.02 374.44C120.02 337.82 142.46 320.49 187.35 322.46C144.34 328.87 121.89 317.02 120.02 286.9C118.14 256.78 147.3 251.95 207.5 272.43" id="a3F7pUiHhx"></path>
          <path class="elms" :style="{ animationPlayState: animationL }" style="animation-delay: 0s; animation-duration: 1.5s" fill="none" stroke="white" stroke-width="15" d="M326.4 410C290.73 410 268.45 410 259.53 410C245.21 410 233.6 398.39 233.6 384.07C233.6 366.81 233.6 323.65 233.6 254.59" id="a2g6TFsHOy"></path>
          <path class="elms elmsM" :style="{ animationPlayState: animationM }" style="animation-delay: 0s; animation-duration: 1.5s" fill="none" stroke="white" stroke-width="15" d="M436.91 415.77C439.16 311.96 430.7 260.06 411.54 260.06C392.38 260.06 383.93 311.96 386.18 415.77C384.58 309.93 374.53 258.01 356.01 260C337.5 261.99 330.64 313.91 335.44 415.77" id="b1UK7TqCNx"></path>
          <path class="elms" :style="{ animationPlayState: animationS }" style="animation-delay: 0s; animation-duration: 1.5s" fill="none" stroke="white" stroke-width="15" d="M452.61 377.83C450.27 389.95 459.44 400.11 480.11 408.31C511.12 420.62 576.73 362.83 494.05 324.25C426.78 292.86 458.8 257.79 498.2 260.11C518.96 261.33 528.09 266.34 525.59 275.13" id="ezUDiB0I3"></path> -->
          <!-- Original -->

          <!-- Cursive -->
          <path style="animation-delay: 1.25s; opacity: 0.3" fill="none" stroke="black" stroke-width="15px" d="M546.45 388.88C552.69 391.55 547.85 405.4 591.21 412C634.57 418.6 646.24 387.36 612.53 351.28C557.71 292.63 599.94 236.92 589.02 262.74C533.48 394.05 495.59 411.88 469.96 403.47C421.02 387.41 495.42 265.08 464.39 262.6C423.79 259.37 365.06 427.27 363 409.68C354.41 336.37 386.81 265.67 371.52 263.48C338.28 258.73 286.43 339.84 282.65 375.71C274 457.85 259.93 376.67 286.32 290C312.71 203.33 275.89 389.59 224.25 403.81C172.6 418.03 162.75 356.7 161.31 305.57C158.09 191.09 208.24 86.99 231.06 84.43C282.55 78.64 248.14 199.84 233.36 241.13C205.11 320.02 144.61 375.21 124.49 389.43C58.03 436.39 18.15 396.61 13.14 368.49C2.33 307.79 46.09 272.23 61.43 269.45C99.47 262.54 100.82 313.77 94.06 324.19C84.54 338.85 64.95 352.35 35.29 364.67" id="ekifY7ryP"></path>
          <path class="cursive-elms" fill="none" stroke="white" stroke-width="15px" d="M546.45 388.88C552.69 391.55 547.85 405.4 591.21 412C634.57 418.6 646.24 387.36 612.53 351.28C557.71 292.63 599.94 236.92 589.02 262.74C533.48 394.05 495.59 411.88 469.96 403.47C421.02 387.41 495.42 265.08 464.39 262.6C423.79 259.37 365.06 427.27 363 409.68C354.41 336.37 386.81 265.67 371.52 263.48C338.28 258.73 286.43 339.84 282.65 375.71C274 457.85 259.93 376.67 286.32 290C312.71 203.33 275.89 389.59 224.25 403.81C172.6 418.03 162.75 356.7 161.31 305.57C158.09 191.09 208.24 86.99 231.06 84.43C282.55 78.64 248.14 199.84 233.36 241.13C205.11 320.02 144.61 375.21 124.49 389.43C58.03 436.39 18.15 396.61 13.14 368.49C2.33 307.79 46.09 272.23 61.43 269.45C99.47 262.54 100.82 313.77 94.06 324.19C84.54 338.85 64.95 352.35 35.29 364.67" id="ekifY7ryP"></path>
          <!-- Cursive -->
        </g>
      </svg>
    </div>

    <span class="loadertext" @click="pauseClick()">
      <div v-html="loadingText"></div>
      <div class="loading-dot"></div>
      <div class="loading-dot" style="animation-delay: 0.2s"></div>
      <div class="loading-dot" style="animation-delay: 0.4s"></div>
    </span>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {
      animationState: ''
    }
  },
  props: {
    isVisible: { type: Boolean, default: false },
    loadingText: { type: String, default: "Loading . . ." },
    testingMode: { type: Boolean, default: false },
    isFullScreen: { type: Boolean, default: false },

    theme1: { type: Boolean, default: false },
    theme2: { type: Boolean, default: true },
    theme3: { type: Boolean, default: false },
    theme4: { type: Boolean, default: false },
    theme5: { type: Boolean, default: false }
  },
  methods: {
    pauseClick: function() {
      this.isVisible = !this.isVisible;

      this.$emit('update:isVisible', this.isVisible);
    },
    themeChanged: function(index) {
      this.theme1 = false;
      this.theme2 = false;
      this.theme3 = false;
      this.theme4 = false;
      this.theme5 = false;

      switch (index) {
        case 0:
          this.theme1 = true;
          break;
        case 1:
          this.theme2 = true;
          break;
        case 2:
          this.theme3 = true;
          break;
        case 3:
          this.theme4 = true;
          break;
        case 4:
          this.theme5 = true;
          break;
      }
    }
  },
  mounted() {
    let attrKeys = Object.keys(this.$attrs);
    if (!attrKeys.includes('mainLoader') && process.env['NODE_ENV'] == 'development') {
      console.warn('Loader - You are using in page loader which is not recommended. Please use main loader (this.$fullscreenLoading) instead.');
    }
  },
  watch: {
    isVisible: function(val) {
      if (val == false) {
        this.animationState = 'paused';
      } else {
        this.animationState = '';
        // setTimeout(() => {
          // alert(this.$refs.cursive.style.animation);
          // this.$refs.cursive.style.animation = 'cursiveAnimation 3s linear infinite';
        // }, 1000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
$theme3-delay: 0.08s;
$theme4-delay: 0.1s;

$width-height: 100px;
$loader-text-width: 100%;
$blink-time: 1.5s;
$interval-time: 0.1s;
$circle-width: 12px;

.background {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  height: calc(100% - #{$top-nav-height});
  width: 100%;
  top: $top-nav-height;
  left: 0px;
  z-index: 9999;
}

.spinner-area {
  position: relative;
  display: flex;
  height: $width-height;
  width: $width-height;
  align-items: center;
  justify-content: center;
  // background-color: green;
}

.loadertext {
  font-weight: bolder;
  font-size: 20px;
  color: white;
  width: fit-content;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  > :first-child {
    margin-right: 15px;
  }
}

.themes {
  display: flex;
  position: absolute;
  justify-content: center;
  top: 10px;
  width: 100%;
  padding: 5px;
  
}

// Region Theme 1 (Ori)
.loader {
  position: absolute;
  border-radius: 100%;
  background-color: transparent;
  border: $circle-width solid transparent;
  height: 100%;
  width: 100%;
}

.top {
  border-top: $circle-width solid white;
  animation: spin 1s linear infinite;
}

.right {
  border-right: $circle-width solid red;
  animation: spin 1s infinite;
}

.bottom {
  border-bottom: $circle-width solid black;
  animation: spin 2s infinite;
}

.left {
  border-left: $circle-width solid blue;
  animation: spin 3s infinite;
}
// End Region Theme 1 (Ori)

// Region Theme 2
.dot {
  position: absolute;
  height: 20%;
  width: 20%;
  left: 0;
  border-radius: 100%;
  animation: move 2s infinite;
}

.theme2 .first {
  background-color: yellow;
  z-index: 6;
}

.theme2 .second {
  background-color: lightblue;
  z-index: 5;
  animation-delay: 0.1s;
}

.theme2 .third {
  background-color: orange;
  z-index: 4;
  animation-delay: 0.2s;
}

.theme2 .fourth {
  background-color: lightcoral;
  z-index: 3;
  animation-delay: 0.3s;
}

.theme2 .fifth {
  background-color: purple;
  z-index: 2;
  animation-delay: 0.4s;
}

.theme2 .sixth {
  background-color: lightgreen;
  z-index: 1;
  animation-delay: 0.5s;
}
// End Region Theme 2

// Region Theme 3
.half {
  border-width: 4px;
  border-style: solid;
  border-radius: 100%;
  transform: rotate(-45deg);
  animation: rotate 3s infinite;
}

.theme3 .first {
  position: absolute;
  border-color: red red transparent transparent;
  height: 100%;
  width: 100%;
  animation-delay: calc(#{$theme3-delay} * 7);
}

.theme3 .second {
  position: absolute;
  border-color: orange orange transparent transparent;
  height: calc(100% - 10px);
  width: calc(100% - 10px);
  animation-delay: calc(#{$theme3-delay} * 6);
}

.theme3 .third {
  position: absolute;
  border-color: yellow yellow transparent transparent;
  height: calc(100% - 20px);
  width: calc(100% - 20px);
  animation-delay: calc(#{$theme3-delay} * 5);
}

.theme3 .fourth {
  position: absolute;
  border-color: green green transparent transparent;
  height: calc(100% - 30px);
  width: calc(100% - 30px);
  animation-delay: calc(#{$theme3-delay} * 4);
}

.theme3 .fifth {
  position: absolute;
  border-color: blue blue transparent transparent;
  height: calc(100% - 40px);
  width: calc(100% - 40px);
  animation-delay: calc(#{$theme3-delay} * 3);
}

.theme3 .sixth {
  position: absolute;
  border-color: indigo indigo transparent transparent;
  height: calc(100% - 50px);
  width: calc(100% - 50px);
  animation-delay: calc(#{$theme3-delay} * 2);
}

.theme3 .seventh {
  position: absolute;
  border-color: purple purple transparent transparent;
  height: calc(100% - 60px);
  width: calc(100% - 60px);
  animation-delay: calc(#{$theme3-delay});
}
// End Region Theme 3

// Region Theme 4
.theme4 .bar {
  height: 10%;
  width: 10%;
  animation: expand 1.5s linear infinite;
}

.theme4 .first {
  margin: 0 3px;
  background-color: red;

}

.theme4 .second {
  margin: 0 3px;
  background-color: orange;
  animation-delay: calc(#{$theme4-delay} * 1);
}

.theme4 .third {
  margin: 0 3px;
  background-color: yellow;
  animation-delay: calc(#{$theme4-delay} * 2);
}

.theme4 .fourth {
  margin: 0 3px;
  background-color: green;
  animation-delay: calc(#{$theme4-delay} * 3);
}

.theme4 .fifth {
  margin: 0 3px;
  background-color: blue;
  animation-delay: calc(#{$theme4-delay} * 4);
}

.theme4 .sixth {
  margin: 0 3px;
  background-color: indigo;
  animation-delay: calc(#{$theme4-delay} * 5);
}

.theme4 .seventh {
  margin: 0 3px;
  background-color: purple;
  animation-delay: calc(#{$theme4-delay} * 6);
}
// End Region Theme 4

// Region Theme 5
.elms {
  stroke-dasharray: 500;
  animation: animate 2s linear infinite;
}

@keyframes animate {
  0% {
    stroke-dashoffset: 0;
  }
  75% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 1000;
  }
}

.elmsM {
  stroke-dasharray: 1000;
  animation: animateM 2s linear infinite;
}

@keyframes animateM {
  0% {
    stroke-dashoffset: 0;
  }
  75% {
    stroke-dashoffset: 2000;
  }
  100% {
    stroke-dashoffset: 2000;
  }
}

.cursive-elms {
  stroke-dasharray: 2600;
  animation: cursiveAnimation 2.5s linear infinite;
}

@keyframes cursiveAnimation {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 5200;
  }
}
// End Region Theme 5

.loading-dot {
  display: inline-block;
  margin: 0 5px;
  height: 10px;
  width: 10px;
  background: linear-gradient(transparent, white 50%);
  border-radius: 100%;
  animation: loading-dot-animation 1s linear infinite;
  margin-bottom: 7px;
}

@keyframes loading-dot-animation {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  55% {
    opacity: 1;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes move {
  5% {
    left: 0;
  }
  45% {
    left: 100%;
  }
  55% {
    left: 100%;
  }
  95% {
    left: 0%;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(-45deg);
  }
  60% {
    transform: rotate(360deg);
  }
  80% {
    transform: rotate(315deg);
  }
  100% {
    transform: rotate(315deg);
  }
}

@keyframes expand {
  0% {
    height: 10%;
  }
  20% {
    height: 100%;
  }
  40% {
    height: 10%;
  }
}

@keyframes leftToRight {
  0% {
    width: 10%;
  }
  30% {
    width: 100%;
    left: 0;
  }
  47% {
    width: 10%;
    left: 90%;
  }
  53% {
    width: 10%;
    left: 90%;
  }
  75% {
    width: 100%;
    left: 0%;
  }
  100% {
    width: 10%;
    left: 0;
  }
}
</style>